import {Lead, Slot, Text, Trail} from '@yandex-delivery/blocks'
import React, {memo} from 'react'
import {useWatch} from 'react-hook-form'

import {AddressWidgetConfig} from '../../../types'
import * as classes from './AddressPointSlot.classes'
import {useAddressPointSlot} from './hooks/useAddressPointSlot'

type AddressPointSlotProps = {
  addressWidgetConfig: AddressWidgetConfig
  name: string
  /**
   * Отвечает за показ восклицательного знака (признак ошибки) рядом с текстом
   * @default false
   */
  hasError?: boolean
  onClick?: VoidFunction
  shouldShowError?: boolean
}

export const AddressPointSlot = memo(
  ({addressWidgetConfig, name, onClick, shouldShowError = true}: AddressPointSlotProps): React.ReactElement => {
    const address = useWatch({name: `${name}.title`})

    const {
      AddressPointDescription,
      Lead: SlotLead,
      Trail: SlotTrail,
    } = useAddressPointSlot(Boolean(address), addressWidgetConfig, shouldShowError)

    return (
      <Slot className={classes.addressPointSlot} Component="button" onClick={onClick} size="l">
        <Lead>{SlotLead}</Lead>
        <Text>
          {AddressPointDescription}
          {address}
        </Text>
        <Trail>{SlotTrail}</Trail>
      </Slot>
    )
  },
)
